"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.sortby"));

var _isFilledIn = _interopRequireDefault(require("../../utilities/isFilledIn"));

var _addFieldInfo = _interopRequireDefault(require("./addFieldInfo"));

var _applyRules = _interopRequireDefault(require("./applyRules"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var documentIsComplete = function documentIsComplete(doc) {
  var acknowledge_type = doc.acknowledge_type,
      crew_acknowledged = doc.crew_acknowledged,
      fields = doc.fields,
      _doc$images = doc.images,
      images = _doc$images === void 0 ? [] : _doc$images;
  if (!images.length) return true;
  var isAcknowledgedIfNeeded = acknowledge_type !== 'C' || crew_acknowledged;
  var isRequiredFieldsFilledIn = fields.every(function (field) {
    return field._derived.isRequired ? (0, _isFilledIn.default)(field.value) : true;
  });
  return isAcknowledgedIfNeeded && isRequiredFieldsFilledIn;
};

var addFieldError = function addFieldError(field, doc, errors) {
  return _objectSpread(_objectSpread({}, field), {}, {
    _derived: _objectSpread(_objectSpread({}, field._derived), {}, {
      error: errors.find(function (_ref) {
        var documentId = _ref.documentId,
            fieldId = _ref.fieldId;
        return documentId === doc.id && fieldId === field.id;
      })
    })
  });
}; // Decorates a document with a `_derived` object containing the following attrs:
// - `error` holds the first document-level (ie. not related to a specific field)
//   error found for this document.
// - `isComplete` is true if the document has all required fields filled in.
// - `isViewable` is true if the document has images & may be viewed by the current user.
// It also decorates each field in the `fields` array with a `_derived` object
// containing the following attrs:
// - `error` holds the first field-level error found for this field.
// - `fieldType` one of `utilities/constants/fieldTypes`
// - `isInitials` whether the field is an initials field
// - `isSignature` whether the field is a signature OR initials field (confusing)
// - `isValidated` whether the field is a validated signature or intitials field
// - `isDisabled` whether field is disabled
// - `isRequired` whether field is mandatory
// - `readOnlyTooltip` the tooltip text to show if the field is disabled
// Lastly it may also overwrite the field's `value` attribute if a rule requires it.


var getDecoratedDocument = function getDecoratedDocument(doc, errors, changedFieldId) {
  // Decorate fields with fieldInfo & errors
  var fields = (doc.fields || []).map(_addFieldInfo.default).map(function (field) {
    return addFieldError(field, doc, errors);
  });
  doc = _objectSpread(_objectSpread({}, doc), {}, {
    fields: fields
  }); // Now apply rules to fields and add to doc again

  fields = fields.map(function (field) {
    return (0, _applyRules.default)(field, doc, changedFieldId);
  });
  doc = _objectSpread(_objectSpread({}, doc), {}, {
    fields: fields
  }); // NOTE The reason we did this in two steps is so that applyRules gets the
  // _derived data for every field in the doc.
  // Add document-level derived data

  var _derived = {
    error: errors.find(function (_ref2) {
      var documentId = _ref2.documentId,
          fieldId = _ref2.fieldId;
      return !fieldId && documentId === doc.id;
    }),
    isComplete: documentIsComplete(doc),
    isViewable: (doc.images || []).length
  };
  doc = _objectSpread(_objectSpread({}, doc), {}, {
    _derived: _derived
  });
  return doc;
}; // Takes the following arguments:
// - `docs` an array of undecorated documents
// - `errors` an optional array of error objects { documentId, fieldId, message }
// - `changedFieldId` an optional id specifying which field was just changed
// Returns a new array of documents with the following changes:
// - Documents are sorted by rank.
// - Documents are decorated with a `_derived` object.
// - Document fields are decorated with a `_derived` object.
// - Document fields may also have their value updated.


var decorateDocuments = function decorateDocuments(docs) {
  var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var changedFieldId = arguments.length > 2 ? arguments[2] : undefined;
  var sortedDocs = (0, _lodash.default)(docs, 'rank');
  return sortedDocs.map(function (doc) {
    return getDecoratedDocument(doc, errors || [], changedFieldId);
  });
};

var _default = decorateDocuments;
exports.default = _default;